import styled from 'styled-components';

const ArticleWrapper = styled.article`
  display: grid;
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
`;
export default ArticleWrapper;
